import React, { Component } from 'react';
const products = [{
  name: 'EDMMax 433W Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/6dd944048a5c4f287302d45b78c79810/large-edm-max-433-w-fast-wire-edm.jpg',
  href: '/listings/4738610-edmmax-433w-fast-wire-edm'
}, {
  name: 'EDMMax 434W Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/7150a42273d93f92e3369248faa73afe/large-0001848_edmmax-434w-fast-wire-edm.jpg',
  href: '/listings/4738614-edmmax-434w-fast-wire-edm'
}, {
  name: 'EDMMax 434WW Fast Wire EDM (Water Only)',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/cdeac7907d51ea9dccb34cc0c8c5a3f5/large-used-edm-max-434-ww-fast-wire-edm.jpg',
  href: '/listings/5536850-2026-edm-network-inc-edmmax-434ww-fast-wire-edm-pure-water-no-additives'
}, {
  name: 'EDMMax 656W Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/bff7ae9d7cfa056b415720c3204ee7a1/large-0001850_edmmax-656w-fast-wire-edm.jpg',
  href: '/listings/4738615-edmmax-656w-fast-wire-edm'
}, {
  name: 'EDMMax 818W Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/56ee30e04d7580555b71e66128562f57/large-edm-max-818-w-fast-wire-edm.jpg',
  href: '/listings/5493315-edmmax-818w-fast-wire-edm'
}, {
  name: 'EDMMax 1800W Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/c202be5ba2a21ee47f4e71f731d2fc80/large-edm-max-1800-w-fast-wire-edm.jpg',
  href: '/listings/4738613-edmmax-1800w-fast-wire-edm'
}];
export function VerticalProductsSection() {
  return <section className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1877">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1878">
        {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1879">
            <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1880">
              <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1881" />
            </a>
            <div className="p-5 flex flex-col flex-grow" data-id="element-1882">
              <a href="/m7_view_item.html" className="no-underline" data-id="element-1883">
                <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1884">
                  {product.name}
                </h3>
              </a>
              <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1885">
                <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1886">
                  Request for Quote
                </a>
                <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1887">
                  More Information
                </a>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}